/**
 * This script requires components/form-elements/autocomplete/_vendor/accessible-autocomplete.min.js.
 */

/* global accessibleAutocomplete */

import isIterable from '../../../js/utilities/is-iterable/u-is-iterable.js';
import ajax from '../../../js/utilities/ajax/u-ajax.js';

/**
 * @param {Node|NodeList|String} elements [Either a Node, a NodeList or a selector string]
 */
function autocomplete (elements) {
	// If a string was provided, use it as a selector
	if (typeof elements === 'string') {
		elements = document.querySelectorAll(elements);
	}
	// Check if elements is iterable, otherwise create an array, which will be empty if elements is `null` or `undefined`
	if (!isIterable(elements)) {
		elements = elements ? [elements] : [];
	}

	for (const element of elements) {

		/**
		 * Before proceding, make sure that:
		 *
		 * 1. accessibleAutocomplete has not already been initialised for this element
		 * 2. The element we want to enable autocomplete for has a data-suggestions-url attribute
		 */
		if (element.classList.contains('autocomplete__input') || !element.hasAttribute('data-suggestions-url')) {
			return;
		}

		let id = element.id;
		let defaultInputValue = element.hasAttribute('data-use-default-value') ? element.value : '';

		// Insert the element that will hold the autocomplete
		let placeholder = element.parentNode;
		element.parentNode.insertBefore(placeholder.firstChild, element);

		// Initialise accessibleAutocomplete
		accessibleAutocomplete({
			element: placeholder,
			name: element.name,
			id: id,
			required: element.required,
			defaultValue: defaultInputValue,
			placeholder: element.placeholder,
			displayMenu: 'overlay',
			confirmOnBlur: false,
			showNoOptionsFound: false,
			source: function (query, populateResults) {
				ajax({
					url: element.getAttribute('data-suggestions-url') + '?q=' + query,
					dataType: 'json',
					onSuccess: response => {
						populateResults(response);
					}
				});
			},
			/**
			 * We want the suggestion without highlighting to be what gets put into the input field,
			 * so we use the `templates` option.
			 * We need to check if there is an actual result to avoid an error when the script is
			 * initialised and there are no suggestions yet.
			 */
			templates: {
				inputValue: result => {
					if (result) {
						return result.Suggestion;
					}
				},
				suggestion: result => {
					if (result) {
						return result.SuggestionHighlighted;
					}
				}
			},
			onConfirm: function (object) {
				if(object.Url && object.Url.length ) {
					window.location.href = object.Url;
				}
			},

			tNoResults: () => element.dataset.noResultsText,
			tStatusNoResults: () => element.dataset.noResultsText
		});

		// Remove the original input field
		element.parentNode.removeChild(element);

		// The input field created by accessibleAutocomplete gets an unnecessary `role` attribute which fails HTML validation, so let’s remove it
		let hatt = document.getElementById(id);
		hatt.removeAttribute('role');
		hatt.setAttribute('aria-haspopup', 'listbox');
		document.getElementById(`${id}__listbox`).setAttribute('aria-labelledby', `${id}__label`);
		document.querySelector('.autocomplete__wrapper').setAttribute('aria-labelledby', `${id}__label`);

		// Enable enter key to submit the form
		hatt.addEventListener('keydown', function (e) {
			if (e.key === 'Enter') {
				hatt.form.submit();
			}
		});
	}
}

export default autocomplete;



// WEBPACK FOOTER //
// ./components/form-elements/autocomplete/c-autocomplete.js